import React from 'react'
import DeclarationTabLayout from 'features/declaration/form/components/DeclarationTabLayout'
import { TransitOperationFormValues } from 'features/declaration/models/schemas/transitOperationFormSchema'
import { DeclarationAdditionalSupplyChainActors } from '../AdditionalSupplyChainActors'
import Consignor from './Consignor'
import Consignee from './Consignee'
import Carrier from './Carrier'

function DeclarationTransitPartiesTab() {
  return (
    <DeclarationTabLayout
      start={(
        <Consignor<TransitOperationFormValues> scope="consignor" nctsScope="transitOperation" />
      )}
      centerLeft={(
        <Consignee<TransitOperationFormValues> scope="consignee" nctsScope="transitOperation" />
      )}
      centerRight={(
        <Carrier />
      )}
      end={(
        <DeclarationAdditionalSupplyChainActors />
      )}
    />
  )
}

export default DeclarationTransitPartiesTab
